import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function UseResendCode() {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [resetCode, setResetCode] = useState();

  const resetPassword = async (e) => {
    e.preventDefault();
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      Email: username,
      Password: password,
      ConfirmPassword: confirmPassword,
      ResetPasswordCode: resetCode,
    });

    let response = await fetch("/use-reset-code", {
      method: "POST",
      body: bodyContent,
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      toast.success(data.message);
    } else {
      toast.error(data.error);
    }
  };

  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
      <Form onSubmit={resetPassword} className="border border-2 p-4 rounded-2" style={{width:600}}>
        <Form.Group className="mb-3 row" controlId="email">
          <div className="col-4">
            <Form.Label className='text-nowrap'>Email</Form.Label>
          </div>
          <div className="col-8">
            <Form.Control
              type="email"
              placeholder="Please enter your email"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3 row" controlId="password">
          <div className="col-4">
            <Form.Label className='text-nowrap'>Password</Form.Label>
          </div>
          <div className="col-8">
            <Form.Control
              type="password"
              placeholder=" Please enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3 row" controlId="confirm-password">
          <div className="col-4">
            <Form.Label className='text-nowrap'> Confirm Password</Form.Label>
          </div>
          <div className="col-8">
            <Form.Control
              type="password"
              placeholder=" Please confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3 row" controlId="reset-code">
          <div className="col-4">
            <Form.Label className='text-nowrap'> Reset Code</Form.Label>
          </div>
          <div className="col-8">
            <Form.Control
              type="text"
              placeholder=" Please enter your code"
              value={resetCode}
              onChange={(e) => setResetCode(e.target.value)}
            />
          </div>
        </Form.Group>
        <div className="text-center">
          <Button type="submit" variant="secondary" className="btn-sm mt-3">
            Reset password code
          </Button>
          <div className="my-2">
            <Link to={"/login"}>Go to login page</Link>
          </div>
        </div>
      </Form>
    </div>
  );
}
